import { render, staticRenderFns } from "./BlockedAccess.vue?vue&type=template&id=085bd007&scoped=true&"
import script from "./BlockedAccess.vue?vue&type=script&lang=js&"
export * from "./BlockedAccess.vue?vue&type=script&lang=js&"
import style0 from "./BlockedAccess.vue?vue&type=style&index=0&id=085bd007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085bd007",
  null
  
)

export default component.exports